import { render, staticRenderFns } from "./ModifierSelection.vue?vue&type=template&id=50027cde&scoped=true&"
import script from "./ModifierSelection.vue?vue&type=script&lang=js&"
export * from "./ModifierSelection.vue?vue&type=script&lang=js&"
import style0 from "./ModifierSelection.vue?vue&type=style&index=0&id=50027cde&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50027cde",
  null
  
)

export default component.exports